<template>
  <div>
    <v-data-table
      :headers="customerRepairBomItemDataTableHeaders"
      :items="customerRepairBomItems"
      class="elevation-1 ma-5 "
      :search="searchCustomerRepairBomItem"
      :loading-text="$t('common_get_data')"
      :no-data-text="$t('common_no_data')"
      :no-results-text="$t('common_no_results')"
      :footer-props="{
        'items-per-page-options': [30, 50, 100],
        'items-per-page-text': $t('item_rows_per_page'),
      }"
      :header-props="headerProps"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>{{ $t('customer_repair_item_toolbar_title') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="searchCustomerRepairBomItem"
            append-icon="mdi-magnify"
            :label="$t('customer_repair_item_search_label')"
            single-line
            hide-details
            clearable
          ></v-text-field>
          <v-dialog v-model="isShowEditCustomerRepairBomItemDialog" fullscreen persistent>
            <v-card>
              <v-card-title>
                <span class="text-h5">{{ $t('common_edit') }}</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <ValidationObserver ref="repairItem">
                    <v-row>
                      <v-col cols="12" sm="6" md="4" lg="4" xl="4">
                        <v-select
                          v-model="editedCustomerRepairBomItem.OriginalType"
                          :disabled="isAllTextFieldDisable"
                          item-value="Type"
                          item-text="Name"
                          :items="originalTypeList"
                          @change="changeOriginalType"
                          label="預設來源"
                        ></v-select>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                        <ValidationProvider
                          :name="$t('customer_repair_item_new_number')"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="editedCustomerRepairBomItem.Number"
                            disabled
                            :error-messages="errors[0]"
                          >
                            <template v-slot:label>
                              <span class="red--text">
                                <strong>* </strong>
                              </span>
                              {{ $t('customer_repair_item_new_number') }}
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                        <ValidationProvider
                          :name="$t('customer_repair_item_new_name')"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="editedCustomerRepairBomItem.Name"
                            disabled
                            :error-messages="errors[0]"
                          >
                            <template v-slot:label>
                              <span class="red--text">
                                <strong>* </strong>
                              </span>
                              {{ $t('customer_repair_item_new_name') }}
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                        <ValidationProvider
                          name="新品維修保固"
                          :rules="{ required: true, regex: /^[0-9]+$/ }"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="editedCustomerRepairBomItem.RepairWarrantyPeriod"
                            @keyup.enter="focusNextInput"
                            :error-messages="errors[0]"
                            :disabled="
                              editedCustomerRepairBomItem.OriginalType !== originalType.Customize
                            "
                          >
                            <template v-slot:label>
                              <span class="red--text">
                                <strong>* </strong>
                              </span>
                              新品維修保固
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                        <ValidationProvider
                          name="新品維修價格"
                          :rules="{ required: true, regex: /^[0-9]+$/ }"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="editedCustomerRepairBomItem.RepairPrice"
                            @change="turnOldRepairPrice"
                            @keyup.enter="focusNextInput"
                            :error-messages="errors[0]"
                            :disabled="
                              editedCustomerRepairBomItem.OriginalType !== originalType.Customize
                            "
                          >
                            <template v-slot:label>
                              <span class="red--text">
                                <strong>* </strong>
                              </span>
                              新品維修價格
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                    <v-row v-if="editedCustomerRepairBomItem.OldItemId">
                      <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                        <v-text-field
                          v-model="editedCustomerRepairBomItem.OldNumber"
                          :label="$t('customer_repair_item_old_number')"
                          disabled
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                        <v-text-field
                          v-model="editedCustomerRepairBomItem.OldName"
                          :label="$t('customer_repair_item_old_name')"
                          disabled
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row v-if="editedCustomerRepairBomItem.OldItemId">
                      <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                        <ValidationProvider
                          name="良品維修保固"
                          :rules="{ regex: /^[0-9]+$/ }"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="editedCustomerRepairBomItem.OldRepairWarrantyPeriod"
                            label="良品維修保固"
                            @keyup.enter="focusNextInput"
                            :error-messages="errors[0]"
                            :disabled="
                              editedCustomerRepairBomItem.OriginalType !== originalType.Customize
                            "
                          ></v-text-field>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                        <ValidationProvider
                          name="良品維修價格"
                          :rules="{ regex: /^[0-9]+$/ }"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="editedCustomerRepairBomItem.OldRepairPrice"
                            label="良品維修價格"
                            @keyup.enter="focusNextInput"
                            :error-messages="errors[0]"
                            :disabled="
                              editedCustomerRepairBomItem.OriginalType !== originalType.Customize
                            "
                          ></v-text-field>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                  </ValidationObserver>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="red darken-1"
                  text
                  @click="closeEditedCustomerRepairBomItem"
                  :disabled="isAllTextFieldDisable"
                >
                  {{ $t('common_cancel') }}
                </v-btn>
                <v-btn color="green darken-1" text @click="updateEditedCustomerRepairBomItem">
                  {{ $t('common_confirm') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.OriginalType`]="{ item }">
        {{ convertOriginalType(item.OriginalType) }}
      </template>
      <template v-slot:[`item.Edit`]="{ item }">
        <v-btn icon @click="isShowEditCustomerRepairBomItemDialogBtn(item)">
          <v-icon small>
            mdi-pencil
          </v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { OriginalType } from '@/js/OriginalType'
import { HttpCustomerRepair } from '@/js/http-Manager'
export default {
  components: {},
  name: 'CustomerRepairBomItem',
  props: {
    customerRepairBomItems: {
      type: Array
    },
    isAllTextFieldDisable: {
      type: Boolean,
      default: false
    },
    customerId: {
      type: String
    },
    bomId: {
      type: String
    }
  },
  data: () => ({
    originalType: OriginalType,
    originalTypeList: [],
    searchCustomerRepairBomItem: '',
    editedCustomerRepairBomItem: {
      OriginalType: 0,
      ItemId: '',
      Number: '',
      Name: '',
      RepairPrice: 0,
      RepairWarrantyPeriod: 0,
      OldItemId: '',
      OldNumber: '',
      OldName: '',
      OldRepairPrice: 0,
      OldRepairWarrantyPeriod: 0
    },
    defaultCustomerRepairBomItem: {
      OriginalType: 0,
      ItemId: '',
      Number: '',
      Name: '',
      RepairPrice: 0,
      RepairWarrantyPeriod: 0,
      OldItemId: '',
      OldNumber: '',
      OldName: '',
      OldRepairPrice: 0,
      OldRepairWarrantyPeriod: 0
    },
    isShowEditCustomerRepairBomItemDialog: false,
    isShowDeleteCustomerRepairBomItemDialog: false,
    editedCustomerRepairBomItemIndex: -1
  }),
  async mounted () {
    await this.getOriginalTypeList()
  },
  watch: {},
  computed: {
    headerProps () {
      return { sortByText: this.$t('installation_acceptance_header_sort') }
    },
    customerRepairBomItemDataTableHeaders () {
      return [
        { text: '預設來源', align: 'start', value: 'OriginalType' },
        { text: this.$t('customer_repair_item_new_number'), align: 'start', value: 'Number' },
        { text: this.$t('customer_repair_item_new_name'), align: 'start', value: 'Name' },
        { text: '新品維修保固期數', align: 'end', value: 'RepairWarrantyPeriod' },
        { text: '新品維修價格', align: 'end', value: 'RepairPrice' },
        { text: this.$t('customer_repair_item_old_number'), align: 'start', value: 'OldNumber' },
        { text: this.$t('customer_repair_item_old_name'), align: 'start', value: 'OldName' },
        {
          text: '良品維修保固期數',
          align: 'end',
          value: 'OldRepairWarrantyPeriod'
        },
        {
          text: '良品維修價格',
          align: 'end',
          value: 'OldRepairPrice'
        },
        { text: this.$t('common_edit'), align: 'center', value: 'Edit', sortable: false }
      ]
    }
  },
  methods: {
    async changeOriginalType () {
      if (this.editedCustomerRepairBomItem.OriginalType !== this.originalType.Customize) {
        let response = await HttpCustomerRepair.GetCustomerRepairBomItemDefault({
          customerId: this.customerId,
          originalType: this.editedCustomerRepairBomItem.OriginalType,
          bomId: this.bomId,
          itemId: this.editedCustomerRepairBomItem.ItemId
        })
        if (response && response.status === 200) {
          this.editedCustomerRepairBomItem = JSON.parse(JSON.stringify(response.data.Data))
        }
      }
    },
    async getOriginalTypeList () {
      let response = await HttpCustomerRepair.GetOriginalTypes()
      this.originalTypeList = response && response.status === 200 ? response.data.Data : []
    },
    convertOriginalType (originalType) {
      return OriginalType.getOriginalTypeName(originalType)
    },
    isShowEditCustomerRepairBomItemDialogBtn (item) {
      this.editedCustomerRepairBomItemIndex = this.customerRepairBomItems.indexOf(item)
      this.editedCustomerRepairBomItem = JSON.parse(JSON.stringify(item))
      this.isShowEditCustomerRepairBomItemDialog = true
    },
    updateEditedCustomerRepairBomItem () {
      this.$emit('setEditedCustomerRepairBomItemIndex', this.editedCustomerRepairBomItemIndex)
      this.$emit('updateEditedCustomerRepairBomItem', this.editedCustomerRepairBomItem)
      this.closeEditedCustomerRepairBomItem()
    },
    closeEditedCustomerRepairBomItem () {
      this.isShowEditCustomerRepairBomItemDialog = false
      this.editedCustomerRepairBomItem = JSON.parse(
        JSON.stringify(this.defaultCustomerRepairBomItem)
      )
    },
    turnOldRepairPrice () {
      if (this.editedCustomerRepairBomItem.OldNumber) {
        this.editedCustomerRepairBomItem.OldRepairPrice = Math.round(
          this.editedCustomerRepairBomItem.RepairPrice * 0.8
        )
      }
    },
    focusNextInput (event) {
      let form = document.getElementsByTagName('input')
      let targets = []
      for (let i = 0; i < form.length; i++) {
        if (
          form[i].type !== 'hidden' &&
          !form[i].disabled &&
          !form[i].readOnly &&
          form[i].type !== 'checkbox'
        ) {
          targets.push(form[i])
        }
      }
      let index = Array.prototype.indexOf.call(targets, event.target)
      if (index !== -1) {
        let next = index + 1
        if (next < targets.length) {
          targets[next].focus()
          targets[next].select()
        }
      }
    }
  }
}
</script>
